import {
  ContainerLevelHistoryEntity,
  containerLevelHolderSelector,
  firstOrUndefined,
  ONE_DAY_IN_MILLIS,
  TransportAssocEntity,
  useSearchTicketContainerLevelsQuery
} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {ScadaChart} from "../../chart/ScadaChart/ScadaChart";
import {useMemo, useState} from "react";
import {skipToken} from "@reduxjs/toolkit/query";
import {useApp} from "../../../providers/RegionProvider/RegionProvider";
import {Grid} from "@mantine/core";
import { BaseContainerSelect } from "../../select/entity/ContainerSelect/BaseContainerSelect";

export type TicketScadaProps = {
  ticket: TransportAssocEntity
}

export const TicketScada = (props: TicketScadaProps) => {
  const {ticket} = props;

  const [container, setContainer] = useState<string | undefined>(ticket.pickupTransport?.containerName);

  const {t} = useTranslation(["common"]);

  const {regionId} = useApp()

  const selectContainerLevelHolder = useMemo(() => {
    return containerLevelHolderSelector()
  }, []);

  const criteria = useMemo(() => {
    const transport = ticket.pickupTransport
    if (regionId && transport && transport.createDttm) {
      return {
        id: ticket.id,
        criteria: {
          regionId: regionId,
          containerId: transport.containerId,
          fromDttm: transport.createDttm - (5 * ONE_DAY_IN_MILLIS),
          toDttm: transport.createDttm + ONE_DAY_IN_MILLIS,
          withTransports: true,
        }
      }
    }
    return skipToken
  }, [ticket, regionId])

  const {holder} = useSearchTicketContainerLevelsQuery(criteria, {
    selectFromResult: (result) => ({
      ...result,
      holder: selectContainerLevelHolder(result),
      isLoading: result.isLoading || result.isFetching,
    })
  });

  const levels = useMemo(() => {
    const values: ContainerLevelHistoryEntity[] = []
    if (holder && container) {
      for (const level of holder.containerLevels) {
        if (level.containerName === container) {
          values.push(level)
        }
      }
    }

    return values
  }, [holder, container])

  return (
    <Grid w="100%">
      <Grid.Col span={12}>
        <BaseContainerSelect
          label={t("common.entity.container", "Container")}
          placeholder={t<string>("common.entity.container.plural", "Containers")}
          entities={holder?.containers}
          defaultValue={container}
          valueMapper={(e) => e.name}
          w={450}
          onEntityChange={(e) => setContainer(firstOrUndefined(e)?.name)}/>
      </Grid.Col>
      <Grid.Col span={12}>
        <ScadaChart
          id={ticket.id + "_scada_chart"}
          transports={holder?.transports}
          levels={levels}
        />
      </Grid.Col>
    </Grid>
  );
};

